<template>
  <v-content>
    <v-container fluid>
      <router-view />
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "Dashboard",
  props: {
    msg: String
  }
};
</script>

<style scoped>
.dashboard {
  background: white;
  padding: 0 1rem;
  border-radius: 25px;
}

.nav-buttons-group {
  /* margin: auto; */
  display: flex;
  /* flex-direction: row; */
  justify-content: center;
}

.nav-button {
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background: rgb(0, 255, 200);
  border: none;
  border-radius: 12px;
  padding: 10px;
  margin-top: 10px;
  margin-left: 5px;
}

.nav-button:hover {
  background: green;
}

.nav-button:focus {
  outline: none;
}
</style>
